/**
 * Contact field patterns shared by the platform validation schemas and the standalone
 * contact-capture widget bundle. Kept free of dependencies (no Yup, no React) so the widget
 * can import it without dragging the platform runtime into a customer's page.
 */

export const EMAIL_PATTERN = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

/** A US phone number, once formatting and the country code have been stripped. */
export const PHONE_DIGITS_PATTERN = /^\d{10}$/;

/** Country code every phone number in the platform is stored and submitted with. */
export const PHONE_COUNTRY_CODE = '+1';
